import React from "react";
import Slider from "react-slick";
import Image from "../../components/Image";
import { col1, col2, col3, col4 } from "../../constants/escrow-account";

const useCases = [
  {
    id: 0,
    colList: (
      <div>
        {col1.map(({ id, text, background }) => (
          <div key={id} className="tailor-child">
            <div
              className="w-full px-[19px] flex max-w-[286px] h-[60px] align-center"
              style={{ backgroundColor: `${background}` }}>
              <Image
                src="https://cashfreelogo.cashfree.com/website/landings/outward-remittance/tick.svg"
                width="20"
                height="20"
                className="ml-0 max-w-[286px] md:max-w-full"
              />
              <div className="md:mt-4 md:mb-3">
                <div className="text-[15px] leading-6 pr-6 md:pr-0 ml-[16px]">
                  {text}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ),
  },
  {
    id: 1,
    colList: (
      <div>
        {col2.map(({ id, text, background }) => (
          <div key={id} className="tailor-child">
            <div
              className="w-full px-[19px] flex max-w-[286px] h-[60px] align-center"
              style={{ backgroundColor: `${background}` }}>
              <Image
                src="https://cashfreelogo.cashfree.com/website/landings/outward-remittance/tick.svg"
                width="20"
                height="20"
                className="ml-0 max-w-[286px] md:max-w-full"
              />
              <div className="md:mt-4 md:mb-3">
                <div className="text-[15px] leading-6 pr-6 md:pr-0 ml-[16px]">
                  {text}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ),
  },
  {
    id: 2,
    colList: (
      <div>
        {col3.map(({ id, text, background }) => (
          <div key={id} className="tailor-child">
            <div
              className="w-full px-[19px] flex max-w-[286px] h-[60px] align-center"
              style={{ backgroundColor: `${background}` }}>
              <Image
                src="https://cashfreelogo.cashfree.com/website/landings/outward-remittance/tick.svg"
                width="20"
                height="20"
                className="ml-0 max-w-[286px] md:max-w-full"
              />
              <div className="md:mt-4 md:mb-3">
                <div className="text-[15px] leading-6 pr-6 md:pr-0 ml-[16px]">
                  {text}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ),
  },
  {
    id: 3,
    colList: (
      <div>
        {col4.map(({ id, text, background }) => (
          <div key={id} className="tailor-child">
            <div
              className="w-full px-[19px] flex max-w-[286px] h-[60px] align-center"
              style={{ backgroundColor: `${background}` }}>
              <Image
                src="https://cashfreelogo.cashfree.com/website/landings/outward-remittance/tick.svg"
                width="20"
                height="20"
                className="ml-0 max-w-[286px] md:max-w-full"
              />
              <div className="md:mt-4 md:mb-3">
                <div className="text-[15px] leading-6 pr-6 md:pr-0 ml-[16px]">
                  {text}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ),
  },
];

const TailorMade = () => {
  return (
    <section>
      <div className="container !py-[60px] overflow-hidden">
        <h3 className="text-[24px] md:text-[28px] text-center mb-[60px]">
          Tailor-made to fit your business use cases
        </h3>
        <div className="integration-slider-card mt-10 md:mt-0 md:mx-[-19px]">
          <Slider
            {...{
              dots: true,
              arrows: false,
              infinite: false,
              speed: 500,
              slidesToShow: 4,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    infinite: false,
                    arrows: false,
                    dots: true,
                  },
                },
              ],
            }}>
            {useCases.map(({ id, colList }) => (
              <div key={id} className="w-full md:w-4/12 px-[20px] pb-10 h-full">
                <div className="relative flex items-center justify-center min-h-[200px] w-full">
                  {colList}
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className="text-center my-[50px] md:my-[0px]">
          <span className="many-more-btn font-medium">And many more...</span>
        </div>
      </div>
    </section>
  );
};
export default TailorMade;
